import { countryMobileCodes } from '../../../shared/constants/CountryOptions';

/**
 * Mobile country options keyed by ISO code (dial codes repeat: +1 is both
 * US and CA, so the dial code alone can't identify an option).
 */
export const DIAL_OPTIONS = countryMobileCodes
  .filter((c) => c?.dial_code && c?.code)
  .map((c) => ({ value: c.code, label: `${c.dial_code} (${c.code})` }));

const DIAL_BY_CODE = Object.fromEntries(
  countryMobileCodes
    .filter((c) => c?.dial_code && c?.code)
    .map((c) => [c.code, c.dial_code]),
);

export const DEFAULT_MOBILE_COUNTRY = 'IN';

export const dialCodeOf = (countryCode) =>
  DIAL_BY_CODE[countryCode] || DIAL_BY_CODE[DEFAULT_MOBILE_COUNTRY] || '+91';

/** India: 10 digits; elsewhere up to 14. */
export const maxMobileDigits = (countryCode) =>
  countryCode === DEFAULT_MOBILE_COUNTRY ? 10 : 14;
